import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL query for fetching all permissions
export const GET_ALL_PERMISSIONS_QUERY = gql`
  query Permissions {
    permissions {
      id
      name
      description
    }
  }
`;

// Types for the response
export interface Permission {
  id: number;
  name: string;
  description: string;
}

export interface GetAllPermissionsResponse {
  permissions: Permission[];
}

// Permissions service class
export class PermissionsService {
  private static instance: PermissionsService;

  private constructor() {}

  public static getInstance(): PermissionsService {
    if (!PermissionsService.instance) {
      PermissionsService.instance = new PermissionsService();
    }
    return PermissionsService.instance;
  }

  // Fetch all permissions
  async getAllPermissions(): Promise<Permission[]> {
    try {
      const response = await apolloClient.query<GetAllPermissionsResponse>({
        query: GET_ALL_PERMISSIONS_QUERY,
        fetchPolicy: 'network-only',
      });
      if (response.errors && response.errors.length > 0) {
        throw response;
      }
      if (!response.data || !response.data.permissions) {
        throw new Error('No data returned from getAllPermissions query');
      }
      return response.data.permissions;
    } catch (error: any) {
      console.error('Error fetching permissions:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const permissionsService = PermissionsService.getInstance();

// Export convenience function
export async function getAllPermissions(): Promise<Permission[]> {
  return permissionsService.getAllPermissions();
}
